module.exports = __webpack_public_path__ + "static/media/royalgreenlogo.aba14fcb.webp";